export function calculateInstallmentBreakdown(product) {
  const planType = product?.selectedPaymentPlan || product?.paymentPlan;
  const termMonths = Number(product?.termMonths) || 1;

  if (planType === 'full') return null;

  let flexibleTermOptions = product?.flexibleTermOptions;
  if (typeof flexibleTermOptions === 'string') {
    try {
      flexibleTermOptions = JSON.parse(flexibleTermOptions);
    } catch {
      flexibleTermOptions = null;
    }
  }

  if (Array.isArray(flexibleTermOptions) && flexibleTermOptions.length > 0) {
    const termOption = flexibleTermOptions.find(
      (opt) => opt.termMonths === termMonths
    );
    if (termOption && termOption[planType]) {
      const downPayment = termOption.downPayment || 0;
      const totalPrice = termOption.totalPrice || 0;
      const totalRemaining = totalPrice - downPayment;

      // Use frontend formula for numberOfInstallments (consistent with cart)
      let numberOfInstallments;
      if (planType === 'monthly') {
        numberOfInstallments = Math.max(termMonths, 1);
      } else if (planType === 'weekly') {
        numberOfInstallments = Math.max(termMonths * 4, 1);
      } else if (planType === 'daily') {
        numberOfInstallments = Math.max(termMonths * 30, 1);
      } else {
        numberOfInstallments = 1;
      }

      const installmentAmount =
        numberOfInstallments > 0 ? totalRemaining / numberOfInstallments : 0;

      return {
        downPayment,
        installmentAmount: Math.round(installmentAmount * 100) / 100,
        numberOfInstallments,
        totalInterest: termOption.totalInterest || 0,
        effectiveRate: termOption.effectiveRate || 0,
      };
    }
  }

  let options;
  if (Array.isArray(product?.paymentOptionsBreakdown)) {
    options = product.paymentOptionsBreakdown;
  } else {
    try {
      options = JSON.parse(product?.paymentOptionsBreakdown || '[]');
    } catch {
      return null;
    }
    if (!Array.isArray(options)) return null;
  }

  const planOption = options.find((opt) => opt.type === planType);
  if (!planOption) return null;

  const downPayment = planOption.downPayment || 0;
  const interestRate = planOption.interestRate || 0;
  const maxMonths =
    options.find((opt) => opt.type === 'monthly')?.months ||
    planOption.months ||
    4;

  const basePrice =
    product?.price ||
    planOption.totalPrice - (planOption.totalInterest || 0) ||
    0;
  const remainingBalance = basePrice - downPayment;

  let numberOfInstallments;
  if (planType === 'monthly') {
    numberOfInstallments = Math.max(termMonths, 1);
  } else if (planType === 'weekly') {
    numberOfInstallments = Math.max(termMonths * 4, 1);
  } else if (planType === 'daily') {
    numberOfInstallments = Math.max(termMonths * 30, 1);
  } else {
    numberOfInstallments = 1;
  }

  const effectiveRate =
    Math.min(Math.max(termMonths - 1, 0), Math.max(maxMonths - 1, 1)) * interestRate;
  const totalInterest = (remainingBalance * effectiveRate) / 100;
  const installmentAmount =
    (remainingBalance + totalInterest) / numberOfInstallments;

  return {
    downPayment,
    installmentAmount: Math.round(installmentAmount * 100) / 100,
    numberOfInstallments,
    totalInterest: Math.round(totalInterest * 100) / 100,
    effectiveRate,
  };
}
